import React from 'react';
import { Heart } from 'lucide-react';
import { contactInfo } from '../data';

export default function Footer({ scrollToSection }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#EDE6DF]/30 border-t border-[#EDE6DF] py-10 md:py-12 text-left">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          
          {/* Logo & Tagline */}
          <div className="md:col-span-5 flex flex-col items-start">
            <button
              onClick={() => scrollToSection('forside')}
              className="flex flex-col items-start group text-left focus:outline-none mb-4"
            >
              <span className="font-sans-clean text-lg md:text-xl tracking-[0.15em] uppercase text-[#4A4A4A] font-semibold select-none transition-transform duration-300 group-hover:scale-[1.02] leading-none mb-1">
                Mette Brisson
              </span>
              <span className="font-sans-clean text-[9px] md:text-[10px] tracking-[0.3em] uppercase text-[#BFC8BE] font-semibold pl-1">
                Psykolog
              </span>
            </button>
            <p className="font-sans-clean text-sm text-[#4A4A4A]/70 max-w-sm leading-relaxed">
              Psykolog med praksisuddannelse med klinik på Frederiksberg. Tilbyder nærværende og professionel terapi til unge, voksne og par.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3 flex flex-col items-start">
            <h4 className="font-serif-elegant text-base text-[#4A4A4A] font-semibold mb-4">
              Hurtige links
            </h4>
            <ul className="space-y-2 font-sans-clean text-xs tracking-wider uppercase">
              <li>
                <button
                  onClick={() => scrollToSection('forside')}
                  className="text-[#4A4A4A]/70 hover:text-[#BFC8BE] transition-colors focus:outline-none"
                >
                  Forside
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('ydelser')}
                  className="text-[#4A4A4A]/70 hover:text-[#BFC8BE] transition-colors focus:outline-none"
                >
                  Jeg hjælper dig med
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('om-mig')}
                  className="text-[#4A4A4A]/70 hover:text-[#BFC8BE] transition-colors focus:outline-none"
                >
                  Om mig
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('kontakt')}
                  className="text-[#4A4A4A]/70 hover:text-[#BFC8BE] transition-colors focus:outline-none"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Contact & Legal */}
          <div className="md:col-span-4 flex flex-col items-start">
            <h4 className="font-serif-elegant text-base text-[#4A4A4A] font-semibold mb-4">
              Klinikoplysninger
            </h4>
            <ul className="space-y-2 font-sans-clean text-sm text-[#4A4A4A]/70">
              <li>{contactInfo.name}</li>
              <li>{contactInfo.address}</li>
              <li>{contactInfo.zipCity}</li>
              <li>
                Tlf: <a href={`tel:${contactInfo.phone}`} className="hover:text-[#BFC8BE] transition-colors font-medium text-[#4A4A4A]">{contactInfo.phone}</a>
              </li>
              <li>
                Email: <a href={`mailto:${contactInfo.email}`} className="hover:text-[#BFC8BE] transition-colors font-medium text-[#4A4A4A]">{contactInfo.email}</a>
              </li>
              <li className="text-xs text-[#4A4A4A]/50 pt-1">
                CVR: {contactInfo.cvr} · Psykolog med praksisuddannelse
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#EDE6DF] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans-clean text-xs text-[#4A4A4A]/50 text-center sm:text-left">
            &copy; {currentYear} Mette Brisson. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center gap-1.5 font-sans-clean text-xs text-[#4A4A4A]/50">
            <span>Udviklet med</span>
            <Heart size={12} className="text-[#BFC8BE] fill-[#BFC8BE]" />
            <span>for tryghed og balance</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
